import { createSelector } from 'reselect';

export const selectEventPanel = (state) => state.EventPanel;
export const selectContent = createSelector(
  selectEventPanel,
  (EventPanel) => EventPanel.eventContent,
);
